import React, { useState, useEffect } from 'react'
import styles from '../about.module.scss'
import cn from 'classnames'

export default function Section ({ data, isFirst }) {
  const [hasLoaded, setHasLoaded] = useState(false)
  // Check if Javascript is fully loaded
  const [openItem, setOpenItem] = useState(false)
  useEffect(() => {
    setHasLoaded(true)
  })
  if (Array.isArray(data)) {
    return (
      <>
        {data?.map((elem, index) => {
          return (
            <section key={index} className={cn({ [styles.container]: true, [styles.firstContainer]: isFirst })}>
              <div onClick={() => setOpenItem(!openItem)} className={styles.title}>
                {' '}
                <h3>{elem.title}</h3>{' '}
                <div
                  className={styles.icon}
                >
                  {hasLoaded
                    ? <img
                        src={
                        openItem ? '/landing/minus.svg' : '/landing/plus-green.svg'
                      }
                        alt={openItem ? 'Green minus icon' : 'Green plus icon'}
                      />
                    : null}
                </div>
              </div>
              {hasLoaded ? (openItem && elem.text) : elem.text}
            </section>
          )
        })}
      </>
    )
  } else {
    return (
      <>
        <section className={cn({ [styles.container]: true, [styles.firstContainer]: isFirst })}>
          <div onClick={() => setOpenItem(!openItem)} className={styles.title}>
            {' '}
            <h3>{data.title}</h3>{' '}
            <div
              className={styles.icon}
            >
              {hasLoaded
                ? <img
                    src={
                        openItem ? '/landing/minus.svg' : '/landing/plus-green.svg'
                      }
                    alt={openItem ? 'Green minus icon' : 'Green plus icon'}
                  />
                : null}
            </div>
          </div>
          {hasLoaded ? (openItem && data.text) : data.text}
        </section>

      </>
    )
  }
}
